import { Link, useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import Login from '../pages/auth/login';
import Register from '../pages/auth/register';
import VerifyEmail from '../pages/auth/verify-email';
import { useAuth, useLogout } from '../../hooks';
import ResetPassword from '../pages/auth/reset-password';

const Header = () => {
  const { pathname } = useLocation();
  const { user } = useAuth();

  const [showLoginModal, setShowLoginModal]
    = useState<boolean>(false);
  const [showRegisterModal, setShowRegisterModal]
    = useState<boolean>(false);
  const [showVerificationModal, setShowVerificationModal]
    = useState<boolean>(false);
  const [showResetPasswordModal, setShowResetPasswordModal]
    = useState<boolean>(false);
  const [resetToken, setResetToken] = useState<string>();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('resetToken');
    if (token) {
      setResetToken(token);
      setShowResetPasswordModal(true);
    }
  }, []);

  return (
    <div className="navigation">
      <div className="secondary-navigation">
        <div className="container">
          <div className="contact">
            <figure>
              <strong>Phone:</strong>+33 75 553-1479 | +49 30 87 078-0385
            </figure>
            <figure><strong>Email:</strong>info@euintlrealty.com</figure>
          </div>
          <div className="user-area">
            {!user && (
              <div className="actions">
                <Link to="#" className="promoted"
                      onClick={() => setShowRegisterModal(true)}>
                  <strong>CREATE ACCOUNT</strong>
                </Link>
                <Link to="#" className="promoted"
                      onClick={() => setShowLoginModal(true)}>
                  <strong>SIGN IN</strong>
                </Link>
              </div>
            )}
            {user && (
              <div className="actions">
                <Link to={`/${user.role}/profile`} className="promoted">
                  <strong>DASHBOARD</strong>
                </Link>
                <Link to="#" className="promoted"
                      onClick={useLogout}>
                  <strong>LOGOUT</strong>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="container">
        <header className="navbar" id="top" role="banner">
          <div className="navbar-header">
            <button className="navbar-toggle" type="button"
                    data-toggle="collapse" data-target=".bs-navbar-collapse">
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"/>
              <span className="icon-bar"/>
              <span className="icon-bar"/>
            </button>
            <div className="navbar-brand nav" id="brand">
              <a href="/">
                <img src="/assets/img/logo.png" alt="brand"/>
              </a>
            </div>
          </div>
          <nav className="collapse navbar-collapse bs-navbar-collapse navbar-right"
               role="navigation">
            <ul className="nav navbar-nav">
              <li className={pathname === '/' ? 'active' : ''}>
                <a href="/">HOME</a>
              </li>
              <li className={pathname === '/about' ? 'active' : ''}>
                <Link to="/about">ABOUT US</Link>
              </li>
              <li className={pathname === '/properties' ? 'active' : ''}>
                <Link to="/properties">PROPERTIES</Link>
              </li>
              <li className={pathname === '/faqs' ? 'active' : ''}>
                <Link to="/faqs">FAQs</Link>
              </li>
              <li className={pathname === '/contact' ? 'active' : ''}>
                <Link to="/contact">CONTACT US</Link>
              </li>
              <li className={pathname === '/terms' ? 'active' : ''}>
                <Link to="/terms">T&Cs</Link>
              </li>
            </ul>
          </nav>
        </header>
      </div>
      <Login isModalVisible={showLoginModal}
             openVerifyEmail={() => setShowVerificationModal(true)}
             handleCancel={() => setShowLoginModal(false)}/>
      <Register isModalVisible={showRegisterModal}
                handleCancel={() => setShowRegisterModal(false)}/>
      <VerifyEmail isModalVisible={showVerificationModal}
                   openLogin={() => setShowLoginModal(true)}
                   handleCancel={() => setShowVerificationModal(false)}/>
      <ResetPassword isModalVisible={showResetPasswordModal} token={resetToken}
                     handleCancel={() => setShowResetPasswordModal(false)}
                     openLoginModal={() => setShowLoginModal(true)}/>
    </div>
  );
}

export default Header;